import React from "react";
import variables from "@/common/globalVariables";
import Bubble from "@/common/UI/Bubble";
import Icon from "@/common/UI/Icon";
import Title from "@/common/UI/Title";
import FavoriteButton from "../JobFavoriteButton/FavoriteButton";
import PrompToRegister from "@/components/users/PrompToRegister";
import Translator from "@/components/hoc/Translator";
import JobCompensationBubbles from "../JobCompensationBubbles";
import JobPerksBubbles from "../JobPerksBubbles";
import SendToFriendButton from "../sendJob/SendToFriendButton";
import ApplyToJobButton from "@/common/UI/ApplyToJobButton";

const jobListingTitleStyles = `
  color: ${variables.lightColor};
  letter-spacing: -0.025em;
  line-height: 1.2;
`;

const JobListingHeader = (props) => (
  <div className="JobListingHeader" data-test="job-listing-header">
    <div className="JobListingHeaderTop">
      <div className="JobListingHeaderCopy">
        <Title
          size={"l"}
          styles={jobListingTitleStyles}
          nomargin
          data-test="title-section"
        >
          <Translator>{props.title}</Translator>
        </Title>
        <p className="JobListingLocation" data-test="location-section">
          <Icon icon="map marker alternate" />
          <Translator>{props.location}</Translator>
        </p>
      </div>
      <div className="JobListingHeaderActions">
        {props.hideFavoriteButton ? null : (
          <PrompToRegister>
            <FavoriteButton
              jobId={props.jobId}
              count={props.favoritesCount}
              compact
            />
          </PrompToRegister>
        )}
        <SendToFriendButton jobId={props.jobId} />
        {props.showApply ? (
          <div className="JobListingApply">
            <ApplyToJobButton
              jobId={props.jobId}
              location={props.location}
              compact
            />
          </div>
        ) : null}
      </div>
    </div>
    <div className="JobListingMeta">
      {(props.showCompensation || !props.perks) && (
        <JobCompensationBubbles
          minCompensation={props.minCompensation}
          maxCompensation={props.maxCompensation}
          onDark
          keepColor
        />
      )}
      {props.showType && (
        <Bubble color="2" onDark>
          <Translator>{props.type}</Translator>
        </Bubble>
      )}
      {props.showPerks && (
        <JobPerksBubbles perks={props.perks} onDark limit={8} />
      )}
    </div>
    <style jsx>{`
      .JobListingHeader {
        width: 100%;
        padding: 36px 44px 28px;
        background: linear-gradient(
          165deg,
          #2d8fb8 0%,
          ${variables.accentColor2} 48%,
          #1c6384 100%
        );
        border-top-right-radius: ${variables.roundedRadius};
        border-top-left-radius: ${variables.roundedRadius};
        z-index: auto;
        position: relative;
      }

      .JobListingHeader :global(.Title h2) {
        font-size: 1.85rem;
        font-weight: 600;
        line-height: 1.22;
        margin: 0;
        color: ${variables.lightColor};
      }

      .JobListingHeaderTop {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 24px;
      }

      .JobListingHeaderCopy {
        min-width: 0;
        flex: 1;
      }

      .JobListingLocation {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 12px 0 0;
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.98rem;
        font-weight: 500;
        letter-spacing: 0.01em;
      }

      .JobListingHeaderActions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
        flex-shrink: 0;
        position: relative;
      }

      .JobListingHeaderActions :global(.ui.button) {
        box-shadow: none;
        font-weight: 600;
        letter-spacing: 0.01em;
      }

      .JobListingHeaderActions :global(.FavoriteButtonWrapper) {
        position: relative;
        align-self: center;
        flex-shrink: 0;
        z-index: 1;
      }

      .JobListingHeaderActions :global(.AnimatedButton) {
        position: relative !important;
      }

      .JobListingHeaderActions :global(.ui.labeled.button) {
        display: inline-flex;
        align-items: stretch;
        height: 32px;
      }

      .JobListingHeaderActions :global(.ui.labeled.button > .button) {
        display: inline-flex !important;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 0 11px 0 10px;
        font-size: 0.78rem;
        line-height: 1;
      }

      .JobListingHeaderActions :global(.ui.labeled.button > .button > .icon) {
        margin: 0 6px 0 0 !important;
        font-size: 0.85em;
      }

      .JobListingHeaderActions :global(.ui.labeled.button > .label) {
        display: inline-flex;
        align-items: center;
        height: 32px;
        padding: 0 9px;
        font-size: 0.78rem;
        line-height: 1;
      }

      .JobListingApply {
        display: flex;
      }

      .JobListingMeta {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 22px;
        align-items: center;
      }

      @media only screen and (max-width: 720px) {
        .JobListingHeader {
          width: 100%;
          padding: 28px 22px 22px;
          border-top-right-radius: 0px;
          border-top-left-radius: 0px;
        }

        .JobListingHeader :global(.Title h2) {
          font-size: 1.45rem;
        }

        .JobListingHeaderTop {
          flex-direction: column;
          gap: 16px;
        }

        .JobListingHeaderActions {
          width: 100%;
          justify-content: flex-start;
        }

        .JobListingApply {
          width: 100%;
        }

        .JobListingApply :global(.Button) {
          width: 100%;
        }
      }
    `}</style>
  </div>
);

export default JobListingHeader;
